import { render, staticRenderFns } from "./StaticResidentialProxy.vue?vue&type=template&id=54f9fa26&scoped=true"
import script from "./StaticResidentialProxy.vue?vue&type=script&lang=js"
export * from "./StaticResidentialProxy.vue?vue&type=script&lang=js"
import style0 from "./StaticResidentialProxy.vue?vue&type=style&index=0&id=54f9fa26&prod&lang=less"
import style1 from "./StaticResidentialProxy.vue?vue&type=style&index=1&id=54f9fa26&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f9fa26",
  null
  
)

export default component.exports